import {
  registerDialogDrawer,
  trackDialogDrawerOpen,
  unregisterDialogDrawer,
} from '@/components/ui/mobile-responsive-dialog-drawer/atoms';
import { DialogDrawerRegistryContextProvider } from '@heidi/design-system/contexts';
import { useSetAtom } from 'jotai';
import { useMemo, type ReactNode } from 'react';

/**
 * Backs the design-system `DialogDrawer` open-state registry with the app's
 * global jotai store. Mounted once at the app root so the `anyDialogDrawerOpenAtom`
 * readers (customise-template-menu, live-transcription split view, evidence
 * onboarding, scribe chat page) can keep their hotkeys/dropdowns from firing
 * while any dialog or drawer is open.
 */
export function DialogDrawerRegistryProvider({ children }: { children: ReactNode }) {
  const register = useSetAtom(registerDialogDrawer);
  const unregister = useSetAtom(unregisterDialogDrawer);
  const trackOpen = useSetAtom(trackDialogDrawerOpen);

  const value = useMemo(
    () => ({ register, unregister, trackOpen }),
    [register, unregister, trackOpen]
  );

  return (
    <DialogDrawerRegistryContextProvider value={value}>
      {children}
    </DialogDrawerRegistryContextProvider>
  );
}
